import { ReactElement } from 'react';
import { Field } from 'formik';
import { CheckboxInput } from '@components';

function ExtensionStep9(): ReactElement {
  return (
    <>
      <div className="vfH2">Declaration</div>
      <div>
        <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
        <p>I understand that it is an offence under the Fines Reform Act 2014 to intentionally provide false or misleading information in a written statement required by or under that Act. I understand that the offence carries a fine in excess of $1500.</p>
        <p>I understand that if Fines Victoria offers me a payment arrangement, failure to make the payment by the due date may result in the arrangement being cancelled. This may result in further costs being added and/or enforcement action being taken against me.</p>
      </div>
      <p>I understand that it is my responsibility to ensure that payment is made on or before the due date.</p>
      <Field component={CheckboxInput} name="declaration" title="I agree to the statements above" />
    </>
  );
}

export default ExtensionStep9;
